/*
 * @ts-nocheck — TS2589 ("type instantiation excessively deep") on the
 * the legacy modal + nested JSX tree here. Runtime behaviour is unaffected.
 * A cleanup pass factoring heavy intrinsic-element trees into smaller
 * components (so inference doesn't blow the recursion budget) would let this
 * drop the directive.
 */
// @ts-nocheck
import {Modal} from "@/widgets/Modal";
import {ModalBody} from "@/widgets/ModalParts";
import { useGetAsset } from "@/hooks/useAsset";
import { useGetGuild } from "@/hooks/useGetGuild";
import { formatDate } from "@/utils/formatDate";
import { SponsoredGuildCompetitionWinnerResponse, WinningCriteria, DistributedRewardResponse, SponsoredCompetitionNotificationMetadata } from "@devour/client";
import { IoMdClose } from "react-icons/io";

interface _props {
    wonCompetition: SponsoredGuildCompetitionWinnerResponse,
    isOpen: boolean,
    onClose: () => void,
    onDismiss: () => void,
}

export const GuildPrizeWonDialogFromDistributedReward = ({
    isOpen,
    onClose,
    onDismiss,
    reward,
}: {
    isOpen: boolean,
    onClose: () => void,
    onDismiss: () => void,
    reward: DistributedRewardResponse
}) => {
    const notificationMetadata = reward.notificationMetadata as SponsoredCompetitionNotificationMetadata;
    const { data: guild} = useGetGuild(notificationMetadata.guildId);
    const {data: guildImage} = useGetAsset(guild?.hero);
    const prizeName = reward?.description;
    const guildName = guild?.name ?? "";
    function getMonthName() {
        const date = new Date(reward.createdAt);
        const monthName = date.toLocaleString("en-US", { month: "long" });
        return monthName;
    }

    const getTitle = () => {
        switch (notificationMetadata.winningCriteria) {
            case WinningCriteria.TOP_OVERALL_XP_GAINER:
                return `You are Guilds Overall XP Winner for ${getMonthName()}!`;
            case WinningCriteria.TOP_GUILD_XP_GAINER:
                return `You are ${guildName} XP Winner for ${getMonthName()}!`;
            case WinningCriteria.WINNING_GUILD:
                return `${guildName} is the Guild Winner for ${getMonthName()}!`;
            default:
                return "";
        }
    };
    const getDescription = () => {
        switch (notificationMetadata.winningCriteria) {
            case WinningCriteria.TOP_OVERALL_XP_GAINER:
                return `You were the Top XP Leader! 🏆 ${prizeName} has been awarded to your account.`;
            case WinningCriteria.TOP_GUILD_XP_GAINER:
                return `You were the top XP leader this month for your winning ${guildName} guild.! 🏆 ${prizeName} has been awarded to your account.`;
            case WinningCriteria.WINNING_GUILD:
                return `You guild was the top XP leader this month! 🏆 ${prizeName} has been awarded to your account.`;
            default:
                return "";
        }
    };
    return (
        <Modal size="xs1" isOpen={isOpen} toggle={onClose} contentClassName="guild-prize-won-dialog">
            <div
                className="guild-prize-won-dialog_background"
                style={{
                    backgroundImage: `url(${guildImage?.cdnUrl})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    height: "6.2rem",
                }}></div>
            <div
                className="guild-prize-won-dialog_shader"
                style={{
                    /* Fade the hero art into the design-system surface ($bo-surface). */
                    background: "linear-gradient(180deg, rgba(22, 22, 27, 0.10) 0%, #16161b 6.2rem)",
                }}
            ></div>
            <IoMdClose className="guild-prize-won-dialog_close" onClick={onClose}/>
            <ModalBody className="guild-prize-won-dialog_body">
                <div className="guild-prize-won-dialog_body_heading">
                    <h6>Congratulations</h6>
                    <h5>{getTitle()}</h5>
                </div>
                <div className="guild-prize-won-dialog_body_content">
                    <div className="guild-prize-won-dialog_body_content_prize-placeholder"></div>
                    <h5>{prizeName}</h5>
                    <span>Awarded on {formatDate(reward.createdAt as any)}</span>
                </div>
                <h6 className="guild-prize-won-dialog_body_description">{getDescription()}</h6>
                <button
                    type="button"
                    className="guild-prize-won-dialog_body_confirm"
                    onClick={onDismiss}
                >
                    Confirm
                </button>
            </ModalBody>
        </Modal>
    );
};